<template>
  <BaseButton v-bind="attrsWithoutClick" :disabled :variant :color :size @click="handleClick">
    <slot>Save</slot>
  </BaseButton>
</template>

<script>
import { captureMessageWithContext } from "@/sentry";
import { useToastStore } from "@/stores/toast";

import BaseButton from "./BaseButton.vue";

export default {
  components: { BaseButton },
  inheritAttrs: false,
  props: {
    disabled: { type: Boolean, default: false },
    successMessage: { type: String, default: "Operation completed successfully." },
    variant: { type: String, default: "filled" },
    color: { type: String, default: "primary" },
    size: { type: String, default: "medium" },
    validateForm: { type: Boolean, default: false },
  },
  setup() {
    return { toastStore: useToastStore() };
  },
  computed: {
    attrsWithoutClick() {
      const { onClick: _unusedClick, ...rest } = this.$attrs;
      return rest;
    },
  },
  methods: {
    extractHandler(callback) {
      return Array.isArray(callback) ? callback[0] : callback;
    },
    async handleClick(event) {
      if (this.validateForm) {
        const form = event.target.closest("form");
        if (form) {
          event.preventDefault();
          if (!form.reportValidity()) return;
        } else {
          void captureMessageWithContext("FeedbackButton: validateForm is set but no form found");
        }
      }
      const clickHandler = this.$attrs.onClick;
      if (!clickHandler) return;
      const click = this.extractHandler(clickHandler);
      return this.toastStore.showFeedback({
        action: click(event),
        successMessage: this.successMessage,
      });
    },
  },
};
</script>
